// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT, vehicleArray } from '../../../constants/globalConstants'
import { DeleteVehicleList, getVehicleDataList, getVehicleDetailsList, postVehicleList, postVehicleupdate } from '../../../redux/actions/VehicleListAction'
import { getUserProfile } from '../../../redux/actions/login'
import VehicleModal from '../../../components/global/VehicleModal'
import EditVehicleModal from '../../../components/global/EditVehicleModal'

import { Circles } from 'react-loader-spinner'
import ConfermationModal from '../../../components/global/ConfermationModal'
import { renderNoResults } from '../../../components/global/NoDataFound'
import { errorMessage } from '../../../constants/errorMessage'
import { sortPortalPermissionByKey, isPermissionExist, hasDuplicateAnyKeyValues, isVehicleLimitExceeded, isActivePermit } from '../../../utils/helper'
import { getActivePermitList } from '../../../redux/actions/PermitListAction'



function VehicleDetails(props) {
    const { dispatch, loader, setVehicleCount, notify, partnerDetails } = props

    // const [isRoc, setIsRoc] = useState(false)
    const [vehicleData, setVehicleData] = useState(vehicleArray)
    const [getVehicleList, setGetVehicleList] = useState(EMPTY_ARRAY)
    const [isModalOpen, setModal] = useState(false)
    const [isModalEditOpen, setModalEditOpen] = useState(false)
    const [submitButtonDisable, setSubmitButtonDisable] = useState(false)
    // const [userDetails, setUserDetails] = useState(EMPTY_OBJECT)

    // for confermation pop-up

    const [confermationModal, setConfermationModal] = useState(false)
    const [deleteItem, setDeleteItem] = useState(EMPTY_ARRAY)
    const [formError, setFormError] = useState(false)
    const [vehicleTypeError, setVehicleTypeError] = useState(false)
    const [vehicleDetailsList, setVehicleDetailsList] = useState(EMPTY_ARRAY)
    const [accessPermissions, setAccessPermissions] = useState('')
    const [displayError, setDisplayError] = useState(null)
    const [permitListData, setPermitListData] = useState(EMPTY_ARRAY)

    // to handle the vehicle for menlo
    const allHaveMst_model = localStorage.getItem('allHaveMst_model') ? JSON.parse(localStorage.getItem('allHaveMst_model')) : true


    // useEffect(() => {
    //     const userData = loggedInUserData()
    //     setUserDetails(userData)
    // },[])
    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
        // setIsRoc(partnerDetails?.slug=='roc' ? true :false)
    }, [EMPTY_ARRAY, partnerDetails])

    useEffect(() => {
        getPermitList()
        dispatch(getVehicleDataList()).then((res) => {
            if (res?.data && res?.data != null) {
                setGetVehicleList(res?.data)
                setVehicleCount(res?.data?.length)
            } else {
                setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            }
        }).catch((err) => {
            setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
        })
        dispatch(getVehicleDetailsList()).then((res) => {
            setVehicleDetailsList(res)
        })
    }, [EMPTY_ARRAY])

    const getPermitList = () => {
        dispatch(getActivePermitList()).then((res) => {
            if (res?.data && res?.data != null) {
                let permit = res?.data?.filter((item) => isActivePermit(item))
                setPermitListData(permit)
            }
        }).catch((err) => {
            console.log('err', err)
        })
    }

    const handleVehicleUpdate = (e, item) => {
        e.preventDefault()
        setVehicleData(vehicleArray)
        let newPyalodVehicle = []

        newPyalodVehicle.push({ 'id': item?.id, 'license_plate': item?.license_plate_number, 'make': item?.make, 'model': item?.model, 'model_id': item?.model_id, 'color': item?.color, 'color_id': item?.color_id, 'style': item?.style || '', 'style_id': item?.style_id || '', 'country': item?.country ? item.country : '', 'state_id': item?.state_id, 'make_id': item?.make == 'Others' ? 0 : item?.make_id, 'vehicle_number': item?.vehicle_number, 'is_default': item?.is_default ? item?.is_default : '0', vehicle_type: item?.vehicle_type ?? '', vehicle_type_id: item?.vehicle_type_id ?? '', permit_ids: item?.permits })

        setVehicleData(newPyalodVehicle)
        setModalEditOpen(true)
    }

    const handleUpdateVehicle = (e) => {
        e.preventDefault()
        let newPyalod = []
        vehicleData.map((item) => {
            // if(isRoc){
            let permit_ids_list = []

            item?.permit_ids?.length > 0 && item?.permit_ids?.map((val) => {
                permit_ids_list.push(val?.id)
            })
            const make = item?.make_id ? '' : (item?.othermake ? (item?.maketext || '') : (item?.make || ''))
            const model = item?.model_id ? '' : (item?.othermodel ? (item?.modeltext || '') : (item?.model || ''))
            // newPyalod.push({ 'id': item?.id, 'license_plate': item?.license_plate, 'make': make, 'make_id': item?.make_id ? item?.make_id : '', 'model': model, 'model_id': item?.model_id ? item?.model_id : '', 'color': item?.color_id ? '' : item?.color, 'color_id': item?.color_id ? item?.color_id : '', 'country': item?.country ? item.country : '', 'state_id': item?.state_id, 'vehicle_number': item?.vehicle_number, })
            const payloadOBJ = { 'id': item?.id, 'license_plate': item?.license_plate, 'make': make, 'make_id': item?.make_id ? item?.make_id : '', 'model': model, 'model_id': item?.model_id ? item?.model_id : '', 'color': item?.color_id ? '' : item?.color, 'color_id': item?.color_id ? item?.color_id : '', 'style': item?.style_id ? '' : item?.style, 'style_id': item?.style_id ? item?.style_id : '', 'is_default': item?.is_default, 'country': item?.country ? item.country : '', 'state_id': item?.state_id, 'vehicle_number': item?.vehicle_number, 'vehicle_type': item?.vehicle_type ?? '', 'vehicle_type_id': item?.vehicle_type_id ?? '', permit_ids: permit_ids_list }
            if (item.is_default == '1') {
                payloadOBJ.status_default = '1'
            }
            newPyalod.push(payloadOBJ)
            //     }else{
            //    newPyalod.push({'id' : item?.id ,'license_plate' : item?.license_plate , 'make' :  item?.make == 'Others' ? item?.maketext  : item?.make , 'model' : item?.othermodel ? item?.modeltext :  item?.model, 'color' : item?.color ,'country' : item?.country ? item.country :'','state_id' : item?.state_id, 'make_id': item?.make == 'Others' ? 0  : item?.make_id,'vehicle_number' : item?.vehicle_number ,})

            //     }
        })
        // const newPyalod = vehicleData?.filter((item) => (item?.license_plate === '') ? null : item)
        const finalPayload = {
            vehicleList: newPyalod
        }

        let checkpermitLinkemplty = true
        if (isPermissionExist(accessPermissions, 'Permit Link with Vehicle') && permitListData?.length > 0) {
            checkpermitLinkemplty = newPyalod?.every((val) => val?.permit_ids?.length > 0)
        }





        // for the vehicle type start 
        const isVehicleTypeExist = newPyalod?.every(item => item?.vehicle_type_id !== '' && item?.vehicle_type_id !== '0')
        if (isVehicleTypeExist == false) {
            setVehicleTypeError(true)
        }

        // for vehicle type end
        if (checkpermitLinkemplty && (newPyalod?.length > 0 && newPyalod?.[0]?.license_plate != '' && newPyalod?.[0]?.license_plate?.length >= 2 && newPyalod?.[0]?.license_plate?.length <= 10) && !submitButtonDisable && (isPermissionExist(accessPermissions, 'Get Vehicle Type') === isVehicleTypeExist)) {
            setFormError(false)
            setSubmitButtonDisable(true)
            dispatch(postVehicleupdate(finalPayload)).then((res) => {
                setModalEditOpen(false)
                if (res?.status === 201 && res.data != null) {
                    notify('success', 'Vehicle Updated Successfully')
                    setFormError(false)
                    setVehicleData(vehicleArray)
                    // vehicleArray?.map((item) => {
                    //     if (item) {
                    //         item['license_plate'] = ''
                    //         item['make'] = ''
                    //         item['make_id'] = ''
                    //         item['model'] = ''
                    //         item['color'] = ''
                    //         item['state_id'] = ''
                    //         item['country'] = ''
                    //         item['maketext'] = ''
                    //         item['modeltext'] = ''
                    //         item['othermake'] = false
                    //         item['othermodel']=false

                    //     }
                    // })
                    setModal(false)
                    setVehicleData(vehicleArray)
                    dispatch(getVehicleDataList()).then((res) => {
                        if (res?.data && res?.data != null) {
                            setGetVehicleList(res?.data)
                            setVehicleCount(res?.data?.length)
                        } else {
                            setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        }
                    }).catch((err) => {
                        setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    })
                    dispatch(getUserProfile())
                    setSubmitButtonDisable(false)
                } else {
                    setSubmitButtonDisable(false)
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                }
            }).catch((errors) => {
                setSubmitButtonDisable(false)
                notify('error', errors?.message ? errors?.message : errorMessage?.somethingWentWrong)
            })
        } else {
            setFormError(true)
        }
    }

    const handleSubmitVehicle = (e) => {
        e.preventDefault()
        let newPyalod = []
        let checkMakeModel = false
        let checkMondatory = false
        let licenseDuplicateCheck = hasDuplicateAnyKeyValues(vehicleData, ['license_plate'])
        vehicleData.map((item) => {
            // if(isRoc){
            let permit_ids_list = []

            if (item?.permit_ids?.length > 0) {
                item?.permit_ids?.map((val) => {
                    permit_ids_list.push(val?.id)
                })
            }
            const make = item?.make_id ? '' : (item?.othermake ? (item?.maketext || '') : (item?.make || ''))
            const model = item?.model_id ? '' : (item?.othermodel ? (item?.modeltext || '') : (item?.model || ''))
            // newPyalod.push({ 'license_plate': item?.license_plate, 'make': make, 'make_id': item?.make ? item?.make_id : '', 'model': model, 'model_id': item?.model_id ? item?.model_id : '', 'color': item?.color_id ? '' : item?.color, 'color_id': item?.color_id ? item?.color_id : '', 'country': item?.country ? item.country : '', 'state_id': item?.state_id, 'vehicle_number': item?.vehicle_number, })
            const payloadOBJ = { 'license_plate': item?.license_plate, 'make': make, 'make_id': item?.make ? item?.make_id : '', 'model': model, 'model_id': item?.model_id ? item?.model_id : '', 'color': item?.color_id ? '' : item?.color, 'color_id': item?.color_id ? item?.color_id : '', 'style': item?.style_id ? '' : item?.style, 'style_id': item?.style_id ? item?.style_id : '', 'is_default': item?.is_default, 'country': item?.country ? item.country : '', 'state_id': item?.state_id, 'vehicle_number': item?.vehicle_number, 'vehicle_type': item?.vehicle_type, 'vehicle_type_id': item?.vehicle_type_id ?? '', permit_ids: permit_ids_list }
            if (item.is_default == '1') {
                payloadOBJ.is_default = '1'
            }
            newPyalod.push(payloadOBJ)
            if (!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory')) {
                if (item?.license_plate == '' || 
                    (item?.make_id == '' && item?.maketext == '' && isPermissionExist(accessPermissions, 'Get Vehicle Make/Modal')) 
                    || (item?.model_id == '' && item?.modeltext == '' && isPermissionExist(accessPermissions, 'Get Vehicle Make/Modal')) 
                    || (item?.color_id == '' && isPermissionExist(accessPermissions, 'Get Vehicle Color')) 
                    || (item?.state_id == ''  && isPermissionExist(accessPermissions, 'Get Vehicle State')))
                    checkMondatory = true
            }

            //check
            if (checkMakeModel == false && item?.make == 'Others') {
                checkMakeModel = vehicleDetailsList?.make?.some((value) => value?.name?.toLowerCase() == item?.maketext?.toLowerCase())
                if (checkMakeModel) {
                    notify('error', `You can not add duplicate ${licenseDuplicateCheck ? 'License Plate and' : ''} Make.`)
                }
            } else if (checkMakeModel == false && item?.make != 'Others' && item?.model == 'Others') {
                let makeList = vehicleDetailsList?.make?.filter((v) => v.name.toLowerCase() == item?.make.toLowerCase())
                checkMakeModel = makeList[0]?.mst_model?.some((value) => value?.name?.toLowerCase() == item?.modeltext?.toLowerCase())
                if (checkMakeModel) {
                    notify('error', `You can not add duplicate ${licenseDuplicateCheck ? 'License Plate and' : ''} Model.`)
                }
            }
        })

        // const newPyalod = vehicleData?.filter((item) => (item?.license_plate === '') ? null : item)
        const finalPayload = {
            vehicleList: newPyalod
        }

        const testToSeeAllErrorsAreEmpty = newPyalod?.every((item) => item?.license_plate !== '')

        let checkpermitLinkemplty = true
        if (isPermissionExist(accessPermissions, 'Permit Link with Vehicle') && permitListData?.length > 0) {
            checkpermitLinkemplty = newPyalod?.every((val) => val?.permit_ids?.length > 0)
        }

        // for the vehicle type start 
        const isVehicleTypeExist = newPyalod?.every(item => item?.vehicle_type_id !== '')
        if (isVehicleTypeExist == false) {
            setVehicleTypeError(true)
        }
        // for vehicle type end
        if (checkMakeModel === false && checkpermitLinkemplty === true && testToSeeAllErrorsAreEmpty === true && (isPermissionExist(accessPermissions, 'Get Vehicle Type') === isVehicleTypeExist) && (newPyalod?.length > 0 && newPyalod?.[0]?.license_plate != '' && newPyalod?.[0]?.license_plate?.length >= 2 && newPyalod?.[0]?.license_plate?.length <= 10) && !submitButtonDisable) {
            setFormError(false)
            setSubmitButtonDisable(true)
            if (licenseDuplicateCheck || checkMondatory) {

                if (checkMondatory) {
                    setFormError(true)
                } else {
                    notify('error', 'You can not add duplicate License Plate.')
                }
                setSubmitButtonDisable(false)
            } else {
                dispatch(postVehicleList(finalPayload)).then((res) => {
                    if (res?.status === 201 && res.data != null) {
                        notify('success', res.data ? res.data : 'Vehicle Added Successfully')
                        setFormError(false)
                        vehicleArray?.map((item) => {
                            if (item) {
                                item['license_plate'] = ''
                                item['make'] = ''
                                item['make_id'] = ''
                                item['model'] = ''
                                item['model_id'] = ''
                                item['color_id'] = ''
                                item['color'] = ''
                                item['style_id'] = ''
                                item['style'] = ''
                                item['state_id'] = ''
                                item['country'] = ''
                                item['maketext'] = ''
                                item['modeltext'] = ''
                                item['othermake'] = false
                                item['othermodel'] = false

                            }
                        })
                        setModal(false)
                        setVehicleData(vehicleArray)
                        dispatch(getVehicleDataList()).then((res) => {
                            if (res?.data && res?.data != null) {
                                setGetVehicleList(res?.data)
                                setVehicleCount(res?.data?.length)
                            } else {
                                setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                            }
                        }).catch((err) => {
                            setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                        })
                        dispatch(getUserProfile())
                        setSubmitButtonDisable(false)
                    } else {
                        setSubmitButtonDisable(false)
                        notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    }
                }).catch((errors) => {
                    setSubmitButtonDisable(false)
                    notify('error', errors?.message ? errors?.message : errorMessage?.somethingWentWrong)
                })
            }
        } else {
            setFormError(true)
        }
    }

    const handleVehicleDelete = (e, item) => {
        e.preventDefault()
        setDeleteItem(item)
        setConfermationModal(true)
    }

    // Delete Vehicle item
    const handleDelete = () => {
        if (deleteItem?.id) {
            dispatch(DeleteVehicleList(deleteItem?.id)).then((res) => {
                if (res?.status === 202 && res?.data !== null) {
                    notify('success', 'Vehicle Deleted')
                    dispatch(getUserProfile())
                    return dispatch(getVehicleDataList()).then((res) => {
                        if (res?.data && res?.data != null) {
                            setGetVehicleList(res?.data)
                            setVehicleCount(res?.data?.length)
                        } else {
                            setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                        }
                    }).catch((err) => {
                        setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                    })
                } else {
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)

                }
            }).catch((errors) => {
                notify('error', errors?.message ? errors?.message : errorMessage?.somethingWentWrong)
            })
            setConfermationModal(false)
        }
    }

    const handleModalOpen = () => {
        setVehicleData(vehicleArray)
        if (isVehicleLimitExceeded(accessPermissions, getVehicleList?.length, partnerDetails?.max_vehicle)) {
            notify('error', `You can not add more than ${partnerDetails?.max_vehicle} Vehicles.`)
            return
        } else {
            vehicleArray?.map((item) => {
                if (item) {
                    item['license_plate'] = ''
                    item['make'] = ''
                    item['make_id'] = ''
                    item['model'] = ''
                    item['model_id'] = ''
                    item['color_id'] = ''
                    item['color'] = ''
                    item['style_id'] = ''
                    item['style'] = ''
                    item['country'] = ''
                    item['state_id'] = ''
                    item['maketext'] = ''
                    item['modeltext'] = ''
                    item['vehicle_number'] = ''
                    item['othermake'] = false
                    item['othermodel'] = false

                }
            })
            setVehicleData(vehicleArray)
            setModal(true)
        }
    }

    const setModalOpen = (isopen) => {
        setFormError(false)
        setModal(isopen)
    }

    return (
        <div>
            <div className="d-flex justify-content-between mb-4">
                {/* <h4 className="fw-bold">Vehicle Details </h4> <button href='#' className="btn btn-success ms-auto" data-bs-toggle="modal" data-bs-target="#vehicleModal"><i className="fa fa-plus"></i> Add</button> */}
                <h4 className="fw-bold">Vehicle Details </h4>
                <button
                    className="btn btn-primary ms-auto"
                    onClick={handleModalOpen}
                    disabled={(loader) ? true : false}
                ><i className="fa fa-plus"></i> Add</button>
            </div>
            {loader ? <span className='ms-2 d-flex justify-content-center'><Circles
                height="50"
                width="50"
                color="var(--bs-primary)"
                ariaLabel="circles-loading"
                visible={true}
            /></span> : <div className="card mb-3">
                <div className="card-header">
                    <b>Vehicle List</b>
                </div>
                {/* <div className="card-body">
                    {getVehicleList?.length > 0 ?
                        <div className='row g-0 align-items-center'>
                            <div className="col-sm-4 mb-3">
                                <p className="mb-0 ms-3"><b>License Plate</b></p>
                            </div>
                            <div className="col-sm-2 mb-3 text-start">
                                <p className="mb-0"><b>Color</b></p>
                            </div>
                            <div className="col-sm-2 mb-3 text-start">
                                <p className="mb-0"><b>Make</b></p>
                            </div>
                            <div className="col-sm-2 mb-3 text-start">
                                <p className="mb-0"><b>Model</b></p>
                            </div>
                            <div className="col-sm-2 text-end mb-3">
                                <b>Action</b>
                            </div>

                            {getVehicleList?.length > 0 ? getVehicleList?.map((getListDataItem, getListDataIndex) => {
                                return <div key={getListDataIndex} className="row g-0 mb-1 align-items-center">
                                    <div className="col-sm-4">
                                        <p className="mb-0 ms-3">{getListDataItem?.license_plate_number}</p>
                                    </div>
                                    <div className="col-sm-2 text-start">
                                        <p className="mb-0">{getListDataItem?.color}</p>
                                    </div>
                                    <div className="col-sm-2 text-start">
                                        <p className="mb-0">{getListDataItem?.make}</p>
                                    </div>
                                    <div className="col-sm-2 text-start">
                                        <p className="mb-0">{getListDataItem?.model}</p>
                                    </div>
                                    <div className="col-sm-2 text-end">
                                        <button className="btn btn-outline-danger px-3 btn-sm" onClick={(e) => handleVehicleDelete(e, getListDataItem)}><i className="fa  fa-trash"></i></button>
                                    </div>
                                </div>
                            }) : renderNoResults()}
                        </div> : renderNoResults()}

                </div> */}

                <div className="card-sm-body table-responsive">
                    {getVehicleList?.length > 0 ? <>
                        <table className="table table-borderless d-none d-sm-table">
                            <thead>
                                <tr>
                                    <th scope="col" className='tableLicensePlate'>License Plate</th>
                                    <th scope="col">Make</th>
                                    {(allHaveMst_model) ? <th scope="col">Model</th> : null}
                                    {isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <th >Vehicle Type</th> : ''}
                                    <th scope="col">Color</th>
                                    {isPermissionExist(accessPermissions, 'Get Vehicle Style') ? <th scope="col">Style</th> : ''}
                                    {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? <th scope="col">Country</th> : ''}

                                    <th scope="col">State</th>
                                    {isPermissionExist(accessPermissions, 'Vin Number') ? <th scope="col">VIN</th> : ''}
                                    {getVehicleList.length > 1 ? <th scope='col'>Action</th> : null}
                                </tr>
                            </thead>
                            <tbody>
                                {getVehicleList?.length > 0 ? getVehicleList?.map((getListDataItem, getListDataIndex) => {
                                    return <tr className={getListDataItem?.is_default == '1' ? 'table-success' : ''} key={getListDataIndex}>
                                        <td>{getListDataItem?.license_plate_number ? getListDataItem?.license_plate_number : '-'}</td>
                                        <td>{getListDataItem?.make ? getListDataItem?.make : '-'}</td>
                                        {(allHaveMst_model) ? <td>{getListDataItem?.model ? getListDataItem?.model : '-'}</td> : null}
                                        {isPermissionExist(accessPermissions, 'Get Vehicle Type') ? <td>{getListDataItem?.vehicle_type ? getListDataItem?.vehicle_type : '-'}</td> : ''}
                                        <td>{getListDataItem?.color ? getListDataItem?.color : '-'}</td>
                                        {isPermissionExist(accessPermissions, 'Get Vehicle Style') ? <td>{getListDataItem?.style ? getListDataItem?.style : '-'}</td> : ''}

                                        {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? <td>{getListDataItem?.country ? getListDataItem?.country : '-'}</td> : ''}

                                        <td>{getListDataItem?.state_code ? getListDataItem?.state_code : '-'}</td>
                                        {isPermissionExist(accessPermissions, 'Vin Number') ? <td>{getListDataItem?.vehicle_number ? getListDataItem?.vehicle_number : '-'}</td> : ''}
                                        <td><button className="btn btn-outline-primary px-3 btn-sm" onClick={(e) => handleVehicleUpdate(e, getListDataItem)}><i className="fa  fa-pencil"></i></button></td>
                                        <td className='text-center'>
                                            {(getVehicleList.length > 1 && getListDataItem?.is_default != '1') ? <button className="btn btn-outline-danger px-3 btn-sm" onClick={(e) => handleVehicleDelete(e, getListDataItem)}><i className="fa  fa-trash"></i></button> : null}
                                            {getListDataItem?.is_default == '1' ? <span className='custom-tooltip mt-1'><i className="text-success fa-regular fa-check-circle default-vehicletool"></i><span className="tooltip-text">Default Vehicle</span></span> : ''}
                                        </td>

                                    </tr>
                                }) : renderNoResults(displayError)}
                            </tbody>
                        </table>
                        <div className='d-sm-none block'>
                            {getVehicleList?.map((getListDataItem, getListDataIndex) => {
                                return <div className={`${getListDataItem?.is_default == '1' ? 'bg-success bg-opacity-10 ' : ''}mb-3 p-2`} key={'mob_' + getListDataIndex} >
                                    <div className='d-flex justify-content-between align-items-end'>
                                        <div>
                                            <div className='color-primary m-0'>{getListDataItem?.license_plate_number ? getListDataItem?.license_plate_number : '-'}</div>
                                            <small className='text-secondary'>
                                                {getListDataItem?.color ? getListDataItem?.color : ''} {getListDataItem?.make ? getListDataItem?.make : ''} {getListDataItem?.model ? getListDataItem?.model : ''} {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? <>{getListDataItem?.country ? getListDataItem?.country : ''}</> : ''} {
                                                    getListDataItem?.state_name ? getListDataItem?.state_name : getListDataItem?.state_code ? getListDataItem?.state_code : ''} {isPermissionExist(accessPermissions, 'Vin Number') ? <>{getListDataItem?.vehicle_number ? getListDataItem?.vehicle_number : ''}</> : ''}
                                            </small>
                                        </div>


                                        <div className='d-flex gap-2 justify-content-center align-items-center'>
                                            <button className="btn p-1 btn-default btn-sm" onClick={(e) => handleVehicleUpdate(e, getListDataItem)}><i className="fa  fa-pencil"></i></button>
                                            {(getVehicleList.length > 1 && getListDataItem?.is_default != '1') ? <><button className="btn p-1 btn-default btn-sm" onClick={(e) => handleVehicleDelete(e, getListDataItem)}><i className="fa text-danger fa-trash"></i></button></> : null}
                                            {getListDataItem?.is_default == '1' ? <span className=' text-center '>
                                                <i className="text-success fa-regular fa-check-circle" title='Default Vehicle'></i>
                                                <small className='d-block' style={{ fontSize: '8px' }}>Default Vehicle</small>
                                            </span> : ''}
                                        </div>
                                    </div>
                                </div>
                            })
                            }
                        </div>
                    </> : renderNoResults(displayError)}
                </div>
            </div>}

            {isModalOpen ? <VehicleModal permitListData={permitListData} partnerDetails={partnerDetails} isModalOpen={isModalOpen} setModal={setModalOpen} modalName='Add Vehicle' submitButtonDisable={submitButtonDisable} vehicleData={vehicleData} setVehicleData={setVehicleData} handleSubmitVehicleData={handleSubmitVehicle} formError={formError} setFormError={setFormError} getVehicleList={getVehicleList} vehicleInputDataLists={vehicleDetailsList} dispatch={dispatch} notify={notify} vehicleTypeError={vehicleTypeError} setVehicleTypeError={setVehicleTypeError} /> : null}
            <ConfermationModal setConfermationModal={setConfermationModal} confermationModal={confermationModal} confermationHeading='Confirm Delete' confermationMessage='Are you sure you want to delete?' buttonLable='Delete' handleDelete={handleDelete} />
            {isModalEditOpen ? <EditVehicleModal permitListData={permitListData} partnerDetails={partnerDetails} isModalOpen={isModalEditOpen} setModal={setModalEditOpen} modalName='Update Vehicle' submitButtonDisable={submitButtonDisable} vehicleData={vehicleData} setVehicleData={setVehicleData} handleSubmitVehicleData={handleUpdateVehicle} formError={formError} setFormError={setFormError} getVehicleList={getVehicleList} vehicleInputDataLists={vehicleDetailsList} dispatch={dispatch} notify={notify} vehicleTypeError={vehicleTypeError} setVehicleTypeError={setVehicleTypeError} /> : ''}

        </div>
    )
}

VehicleDetails.propTypes = {
    dispatch: PropTypes.func,
    data: PropTypes.object,
    loader: PropTypes.bool,
    setUserData: PropTypes.func,
    setVehicleCount: PropTypes.func,
    vehicleCount: PropTypes.number,
    notify: PropTypes.func,
    partnerDetails: PropTypes.object,
}

VehicleDetails.defaulProps = {
    dispatch: noop,
    data: EMPTY_OBJECT,
    loader: PropTypes.bool,
    setUserData: PropTypes.func,
    setVehicleCount: noop,
    vehicleCount: 0,
    notify: noop,
    partnerDetails: EMPTY_OBJECT,
}

function mapStateToProps({ vehicleListReducer }) {
    return {
        loader: vehicleListReducer?.loader,
    }
}
export default connect(mapStateToProps)(VehicleDetails)